import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static outlets = ["fonts--site-font"];

  goBackToFontPreview() {
    this.fontsSiteFontOutlet.discardChanges();
    this.fontsSiteFontOutlet.hideBackBtnLink();
    app.sidebar.dirty = false;
    $('#fonts_tab').css('padding-top', '1rem');
  }
}
